import { render, staticRenderFns } from "./devisCommentsList.vue?vue&type=template&id=3262cead&"
import script from "./devisCommentsList.vue?vue&type=script&lang=js&"
export * from "./devisCommentsList.vue?vue&type=script&lang=js&"
import style0 from "./devisCommentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports